import React, {FC} from 'react';

interface IEmptyStateProps {
  title: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}

export const EmptyState: FC<IEmptyStateProps> = ({title, action, children}) => (
  <div className="rounded-lg border border-dashed border-[#dcdee5] bg-[#fbfbfc] p-8 text-center">
    <div className="text-[15px] font-medium text-[#33364b]">{title}</div>
    <div className="mx-auto mt-1 max-w-[440px] text-[13px] text-gray-500">{children}</div>
    {action && <div className="mt-4 flex justify-center">{action}</div>}
  </div>
);
